export default __webpack_public_path__ + "static/media/thick_blueanim.9ca4965a.gif";